import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { UiHelper } from '../../common/helpers/UiHelper';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppTheme } from '../../styles/AppTheme';

export class EventVideoList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if(!this.props.videosReady) {
      return (
        <div className={css(Styles.progressContainer)}>
          <CircularProgress size={48} className={css(Styles.progress)} />
        </div>
      )
    }
    if(this.props.data && this.props.data.length === 0) {
      return (
        <div className={css(Styles.progressContainer)}>
          <p>No videos found.</p>
        </div>
      )
    }
    return (
      <div className={css(Styles.eventListContainer)} >
        {this.props.data.map((item,index) => {
          return (
            <div onClick={e => this.props.eventVideoDialog(item,index)} className={css(Styles.eventInnerContainer)}>
              <div className={css(Styles.eventListInnerContainer)}>
                <div className={css(Styles.eventListTitleConatiner)}>
                  <p className={css(Styles.eventListDate)}>{moment(item.time).format('MMM DD, YYYY, h:mm:ss A')}</p>
                </div>
                <div className={css(Styles.eventTypeConatiner)}>
                  <Icon color='secondary'>
                  videocam
                  </Icon>
                </div>
              </div>
              <Divider />
            </div>
          )
        })}
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  eventListContainer: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '70vh',
    overflow: 'scroll',
  },
  eventInnerContainer: {
    cursor: 'pointer',
    ':hover' : {
      backgroundColor:AppTheme.secondaryBg
    }
  },
  eventListInnerContainer: {
    display: 'flex',
    padding: 8,
    overflow: 'hidden'
  },
  eventListTitleConatiner: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10,
    justifyContent: 'center'
  },
  eventListDate: {
    margin: 0,
    fontSize: 13,
    fontWeight: 'bolder'
  },
  eventTypeConatiner: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 300
  },
})



// WEBPACK FOOTER //
// ./src/common/components/EventVideoList.js